import { Box } from '@mui/material';
import { ReactNode } from 'react';

type IncTabPanelProps = {
  value: number;
  index: number;
  children: ReactNode;
};

const IncTabPanel = ({ value, index, children, ...rest }: IncTabPanelProps) => {
  return (
    <Box role="tabpanel" hidden={value !== index} {...rest}>
      {value === index && children}
    </Box>
  );
};

export default IncTabPanel;
